<div class="accordion-container" [ngClass]="[step.isListItemOpened ? 'open' :'']"
  *ngFor="let step of subSectionSteps; let i = index">
  <!-- <div > -->
  <form #stepsForm="ngForm" autocomplete="off" novalidate>
    <ion-item [ngClass]="[step.compliance && step.compliance ==='notApplicable'?'div-background-green' : '',step.compliance && step.compliance ==='yesCompliant'?'div-background-green' : '']" class="ion-item-css" lines="none" (click)="toggleAccordion(step,i,subSectionSteps)">
      <!--[disabled]='step.maskAsComplete'-->
      <ion-label>{{step.stepBody || 'Add A Question' | translate}}</ion-label>
      <span *ngIf="step?.compliance==='hazard'"> {{ 'No. Of Hazards' | translate}}-{{step.hazardCount}}</span>
      <span *ngIf="step?.compliance !=='hazard'">{{(step?.compliance==="yesCompliant")?"Yes, Compliant":(step?.compliance==="notApplicable")?"Not applicable":'' | translate}}</span>
      <!-- <ion-label>No. Of Hazards-1</ion-label> -->
      <!--{{subSectionName}} -->
      <ion-icon style="font-size: 20px;padding: 8px;"  (click)="deleteStep(step,i)"
        name="trash-outline"></ion-icon><!--*ngIf="!step.id"-->
      <ion-icon name="chevron-down-outline"></ion-icon>
    </ion-item>
    <div class="content">
      <div class="question-container" *ngIf="isCustom">
        <ion-label> {{ 'Question' | translate}} *</ion-label>
        <ion-item lines=none>
          <ion-textarea [autoGrow]="true" rows="6" cols="20" [disabled]="this.roadmapStatus==='Completed'" [(ngModel)]="step.stepBody" name="stepBody" required #stepBody="ngModel"
            placeholder="{{'Add a Question'|translate}}" ></ion-textarea>
        </ion-item>
        <ion-text style="font-size: x-small; font-weight: bold" *ngIf="stepBody.invalid && stepBody.touched"
          color="danger">
          Required
        </ion-text>
      </div>

      <div class="question-container">
        <ion-label> {{ 'Notes' | translate}}</ion-label>
        <ion-item lines=none>
          <ion-textarea [autoGrow]="true" [(ngModel)]="step.stepNote" name="stepNote" #stepNote="ngModel">
          </ion-textarea>
          <ion-icon *ngIf="step.padLock" style="padding: 9px;" name="lock-closed-outline"  color="success" (click)="step.padLock=false"></ion-icon>
          <ion-icon *ngIf="!step.padLock" style="padding: 9px;" name="lock-open-outline" color="danger"  (click)="step.padLock=true"></ion-icon>
        </ion-item>
        <!-- <ion-text style="font-size: x-small; font-weight: bold" *ngIf="stepNote.invalid && stepNote.touched"
              color="danger">
              Required
            </ion-text> -->
      </div>
      <ion-list class="radio-list" >
        <ion-radio-group [(ngModel)]="step.compliance" name="compliance" #compliance="ngModel"
          (ionChange)="checkComplianceType(step.compliance)">
          <ion-row>
            <ion-col size="3">
              <ion-item lines='none'>
                <ion-label class="coccc-radio-title"> {{ 'Yes, Compliant' | translate}}</ion-label>
                <ion-radio mode='md' item-left slot="start" [disabled]="!step.stepBody ||this.roadmapStatus==='Completed'" value="yesCompliant"
                  class="coccc-circle-style">
                </ion-radio>
              </ion-item>
            </ion-col>
            <ion-col size="3">
              <ion-item lines='none'>
                <ion-label class="coccc-radio-title"> {{ 'Not applicable' | translate}}</ion-label>
                <ion-radio mode='md' item-left slot="start" [disabled]="!step.stepBody || this.roadmapStatus==='Completed'" value="notApplicable"
                  class="coccc-circle-style">
                </ion-radio>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-text style="font-size: x-small; font-weight: bold" *ngIf="compliance.invalid && compliance.touched"
            color="danger">
            Required
          </ion-text>
        </ion-radio-group>
      </ion-list>
     
      <div *ngIf="step.compliance==='yesCompliant' && step.isListItemOpened">
        <ion-row>
          <ion-col size="12" class="upload-img">{{'Upload Images' | translate}} </ion-col>
          <ion-col size="1" *ngIf="this.roadmapStatus!=='Completed'">
            <input style="display: none;" type="file" accept=".png,.jpeg,.jpg" #complaintImage [id]="'file-inp' + subSectionIndex + '#'  + i"
              (change)="uploadFile($event,step,i,complaintImage)" />
            <label [for]="'file-inp' + subSectionIndex + '#' + i">
              <div class="upload-div">
                <ion-icon slot="start" name="add-circle-outline"></ion-icon>
              </div>
            </label>
          </ion-col>
          <ion-col size="12">
            <ion-row>
              <ion-col size="4" *ngFor="let eachImg of step.previewImages;let i=index">
                <ion-list class="machineLimitsPreview" style="width: auto;">
                  <div style="position:relative; width:'mainimagewidth'">
                    <img [src]="eachImg.img" style="height: 8rem;width:90%;margin-right: -22px;" alt="" />
                    <span style="position:absolute; top:0;" *ngIf="this.roadmapStatus!=='Completed'">
                      <ion-icon name="close-circle-outline" style="font-size: x-large;"
                        (click)="deleteImage(eachImg,step.previewImages,i)"></ion-icon>
                    </span>
                  </div>
                </ion-list>

              </ion-col>
              <ion-col size="12" style="padding-left: 20px;" *ngIf="step?.hasOwnProperty('answers')">
                <!-- <div *ngFor="let name of step?.answers[0]?.complaintMedia">
                  {{name.fileName}}
                </div> -->
                
                <ion-row>
                  <ion-col size="4" *ngFor="let each of step?.answers[0]?.complaintMedia;let i=index">
                    <!-- <a target="_blank" href="{{each.url}}">{{each.fileName}}</a> -->
                    <div *ngIf="each.imgUrl" style="position:relative; width:'mainimagewidth'">
                      <!-- <img [src]="each.img" style="height: 8rem;margin-right: -22px;" alt="" /> -->
                      <img [src]="each.imgUrl" style="height: 8rem;width:90%;margin-right: -22px;" alt="" />
                      <span style="position:absolute; top:0;" *ngIf="this.roadmapStatus!=='Completed'">
                        <ion-icon name="close-circle-outline" style="font-size: x-large;"
                          (click)="deleteImage(each,step?.answers[0]?.complaintMedia,i)"></ion-icon>
                      </span>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>

    </div>
  </form>
  <!-- </div> -->
</div>